var exports = {
  "k": "TabInline.module__container___bzQtYm",
};

module.exports = exports;
